import { ColumnDef } from "@tanstack/react-table";
import { formatMoney } from "@/core/utils/money";
import { IReferral } from "@/referrals/referral";

const DealSizeCol = (): ColumnDef<IReferral> => ({
  header: "Deal size",
  accessorKey: "deal_size",
  cell: ({ row }) => (
    <span className="tabular-nums">
      {formatMoney(row.original.deal_size) || "–"}
    </span>
  ),
  size: 120,
  meta: { align: "right" },
});

export default DealSizeCol;
